import TextField from '@mui/material/TextField'
import type { FC } from 'react'
import { Controller, get, useFormContext } from 'react-hook-form'
import { IMaskMixin } from 'react-imask'
import type { InputProps } from './types'

const IMask = IMaskMixin(({ inputRef, InputProps, ...rest }) => {
  return (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    <TextField InputProps={InputProps} inputRef={inputRef} {...(rest as any)} />
  )
})

export const Input: FC<InputProps> = (props) => {
  const { InputProps, name, variant = 'filled', ...rest } = props
  const { control, formState } = useFormContext()

  const error = get(formState.errors, name)

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { value, onChange, ref } }) => (
        <IMask
          inputRef={ref}
          error={error}
          variant={variant}
          value={value}
          onAccept={onChange}
          onChange={onChange}
          InputProps={InputProps}
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          {...(rest as any)}
        />
      )}
    />
  )
}
